import styled from 'styled-components'
import Button from '@material-ui/core/Button'

Footer = (props)->
	year = Date.create().format('{year}')
	
	<Wrapper>
		<Innerwrap>
			<Copyright>{"Copyright © #{year} #{process.env.APP_NAME}.com. All Rights Reserved."}</Copyright>
			<ButtonWrapper>
				<Button variant="outlined" style={{borderColor: "#FAC507"}} >
					<EidtMyCard href="https://form.jotform.com/210697273969169">{"Edit My Card"}</EidtMyCard>
				</Button>
				<Button variant="contained" style={{backgroundColor: "#FAC507", boxShadow: "none"}}>
					<ContactLink href="/card/get-in-touch">{"Get in touch"}</ContactLink>
				</Button>
			</ButtonWrapper>
		</Innerwrap>
	</Wrapper>


Wrapper = styled.div"""
	box-sizing: border-box
	padding: 25px 20px
	border-top: 1px solid #dddddd;
	background-color: #f9f7f1;

	@media (max-width: 1250px) {
		padding-bottom: 70px
	}
"""

Innerwrap = styled.div"""
	box-sizing: border-box
	max-width: 1170px
	display: flex
	justify-content: space-around
	align-items: center;
	width: 100%
	margin: 0 auto;
	
	@media(max-width: 812px) {
		display: block
	}
"""

ButtonWrapper = styled.div"""
	font-size: 12px
	display: flex
	column-gap: 20px
	justify-content: center
	margin: 10px 0 10px 0
"""

Copyright = styled.div"""
	font-size: 13px
	font-weight: 400
	color: #818990

	@media(max-width: 812px) {
		text-align: center
	}
"""

EidtMyCard = styled.a"""
	display: block
	font-size: 12px
	font-weight: 600
	color: #FAC507
	padding: 2px 0 2px 0
	
	&:hover {
		text-decoration: underline
	}

	@media(max-width: 812px) {
		text-align: center
	}
"""

ContactLink = styled.a"""
	display: block
	font-size: 12px
	font-weight: 600
	color: white
	padding: 2px 0 2px 0
	
	&:hover {
		text-decoration: underline
	}

	@media(max-width: 812px) {
		text-align: center
	}
"""

export default Footer